/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2022 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 *
 * Created by H144765 on 3/31/2022.
 */

import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {Form, Message} from 'semantic-ui-react'
import {Grid, Input, Button} from '@scuf/common';
import LanguagePicker from '../lang/LanguagePicker'
import {changeLanguage, getCurrentLanguage, getFieldErrorMessage} from '../utils/Helpers'
import {injectIntl, FormattedMessage} from 'react-intl';
import * as SecurityActions from '../security/SecurityActions';
import {Routes} from '../utils/Routes'
import {loginModel} from "../model/Login";
import {getSSOclientId} from "../api/Security";
import {userHasActivity} from "../security/SecurityUtils";
import {ACTIVITY_TYPES} from "../security/SecurityConst";

class Login extends Component {
    constructor(props) {
        super(props);

        const {intl} = this.props

        this.state = {
            userName: '',
            password: '',
            errors: [],
            badCredentials: false,
            ssoLoading: false,
            clientId: null,
        }

        this.loginModel = loginModel(intl)

        this.handleUsernameChange = this.handleUsernameChange.bind(this);
        this.handlePasswordChange = this.handlePasswordChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleSSOlogin = this.handleSSOlogin.bind(this)
    }

    componentDidMount() {
        this.props.history.push(Routes.LOGIN)
        const me = this
        getSSOclientId().then(
            function (response) {
                me.setState({clientId: response[0]})
            }
        )
    }

    handleUsernameChange(value) {
        this.handleInputChange(value, 'userName')
    }

    handlePasswordChange(value) {
        this.handleInputChange(value, 'password')
    }

    handleInputChange(value, name) {
        this.setState({[name]: value});
    }

    handleSubmit() {
        this.setState({badCredentials: false})
        this.loginModel.validate({userName: this.state.userName, password: this.state.password}, {abortEarly:false}).then(() => {
            this.setState({errors: []})
            this.props.SecurityActions.signIn(this.state.userName, this.state.password).then((profile) => {
                    if (profile) {
                        const flagHDA = userHasActivity(profile, ACTIVITY_TYPES.HDA_FUNCTIONALITIES) ? '_hda' : ''
                        if ((!this.props.build.isSingleLanguage) && (getCurrentLanguage() !== profile.languageCode + flagHDA)) {
                            changeLanguage(profile.languageCode + flagHDA)
                        } else {
                            this.props.history.push(Routes.HOME)
                        }
                    }
                }
            ).catch(() => this.setState({badCredentials: true}))
        }).catch(err => {
            this.setState({
                errors: err.inner.map(i => {
                    return {path: i.path, message: i.errors}
                }),
            })
        })
    }

    handleSSOlogin() {
        // get the SSO url
        const ssoUrl = this.props.build.ssoUrl

        const scope = window.location.href + 'api'
        const redirect_uri = window.location.href + 'auth'
        const redirectUrl =
            ssoUrl + '/as/authorization.oauth2?client_id=' +
            this.state.clientId +
            '&response_type=code&scope=email+openid+profile+' +
            scope + '&redirect_uri=' + redirect_uri
        window.location.replace(redirectUrl)
    }

    render() {
        const {intl, security, build} = this.props

        const username = intl.formatMessage({id:"login.username"});
        const password = intl.formatMessage({id:"login.password"});

        if (this.state.ssoLoading) {
            this.handleSSOlogin()
        }
        // change language when property isSingleLanguage is set. It is not set during rendering, it would be rendering in the loop
        // change language when saved language in local storage is different from requested language
        const flagHDA = build.isHdaEnvironment ? '_hda' : ''
        if(build.isSingleLanguage && (getCurrentLanguage() !== build.isSingleLanguage + flagHDA)){
            changeLanguage(build.isSingleLanguage + flagHDA)
        }

        const hda = this.props.build.isHdaEnvironment === 'true' ? '-hda' : ''

        return (
            <div id="login-wrapper" className={'login-background' + hda}>
                {!build.isSingleLanguage ?
                    <div className="lang">
                        <LanguagePicker/>
                    </div>
                    :
                    null
                }
                <div id="login-panel" className={'login-panel' + hda}>
                    <div id="login-logo">
                        <div id={"hon-logo" + hda}></div>
                        <div id="logo-title"><span>{this.props.build.name}</span></div>
                    </div>
                    <Form>
                        <Grid>
                            {build.localAccountsDisabled !== 'true' ?
                                <div className="local-account">
                                    <Grid.Row>
                                        <Grid.Column width={12}>
                                            <Input onChange={this.handleUsernameChange} fluid
                                                   error={getFieldErrorMessage('userName', this.state.errors)}
                                                   label={username} placeholder={username}/>
                                        </Grid.Column>
                                    </Grid.Row>
                                    <Grid.Row>
                                        <Grid.Column width={12}>
                                            <Input onChange={this.handlePasswordChange} fluid
                                                   error={getFieldErrorMessage('password', this.state.errors)}
                                                   type="password" label={password} placeholder={password}/>
                                        </Grid.Column>
                                    </Grid.Row>
                                    <Grid.Row>
                                        <Grid.Column width={12}>
                                            <div>
                                                <Button actionType="submit" id="login-submit"
                                                        onClick={this.handleSubmit}
                                                        loading={security.loading}><FormattedMessage id="login.login"/></Button>
                                                <Message error
                                                         content={intl.formatMessage({id: "login.validation.badCredentials"})}
                                                         visible={this.state.badCredentials}/>
                                            </div>
                                        </Grid.Column>
                                    </Grid.Row>
                                </div>
                                : null
                            }
                            {
                                build.localAccountsDisabled !== 'true' && this.state.clientId ?
                                    <Grid.Row>
                                        <Grid.Column width={12}>
                                            <div className="textInCenter">{"OR"}</div>
                                        </Grid.Column>
                                    </Grid.Row>
                                    :
                                    null
                            }
                            {
                                this.state.clientId ?
                                    <Grid.Row>
                                        <Grid.Column width={12}>
                                            <div>
                                                <Button actionType="button"
                                                        onClick={() => this.setState({ssoLoading: true})}
                                                        loading={this.state.ssoLoading}><FormattedMessage
                                                    id="login.SSO"/></Button>
                                            </div>
                                        </Grid.Column>
                                    </Grid.Row>
                                    :
                                    null
                            }
                        </Grid>
                    </Form>

                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        security: state.security,
        build: state.version.build,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        SecurityActions: bindActionCreators(SecurityActions, dispatch),
    }
}
export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(Login))